<div class="grid grid-cols-2 gap-4">
  <mat-checkbox class="col-span-1" [disabled]="true" [checked]="true">
    {{ 'RESULT.VISIBILITY_OPTIONS.MANUAL_PREDICTION' | translate }}
  </mat-checkbox>

  @if (showIntervalOption) {
    <mat-checkbox
      class="col-span-1"
      [disabled]="isLoading()"
      [(ngModel)]="showInterval"
      (ngModelChange)="onShowIntervalChange($event)"
    >
      {{ 'RESULT.VISIBILITY_OPTIONS.SHOW_INTERVAL' | translate }}
    </mat-checkbox>
  }

  @if (showInterval) {
    <div>
      <div class="flex mb-2">
        <pm-subtitle>
          {{ 'RESULT.VISIBILITY_OPTIONS.INTERVAL_TYPE' | translate }}
        </pm-subtitle>
        <pm-icon
          [icon]="InfoIcon"
          class="ml-1 mt-0.5"
          [pmTooltip]="
            intervalType === 'confidence'
              ? ('RESULT.VISIBILITY_OPTIONS.CONFIDENCE_INTERVAL_DESCRIPTION'
                | translate: { value: intervalValue() * 100 | number: '1.0-0' })
              : intervalType === 'prediction'
                ? ('RESULT.VISIBILITY_OPTIONS.PREDICTION_INTERVAL_DESCRIPTION'
                  | translate
                    : {
                        value: intervalValue() * 100 | number: '1.0-0',
                        target: targetValue,
                      })
                : ''
          "
        ></pm-icon>
      </div>
      <mat-radio-group
        [disabled]="isLoading()"
        [(ngModel)]="intervalType"
        (ngModelChange)="onIntervalTypeChange($event)"
      >
        @for (option of intervalOptions; track option) {
          <mat-radio-button
            class="block mb-1"
            [value]="option.value"
            color="primary"
          >
            <p>{{ option.label | translate }}</p>
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  }
  @if (showInterval) {
    <div class="col-span-1 flex flex-col w-full">
      <pm-subtitle>
        {{ 'RESULT.CONFIDENCE_SLIDER.TITLE' | translate }}
      </pm-subtitle>
      <mat-slider
        class="confidence"
        [step]="sliderOptions.step"
        [min]="sliderOptions.floor"
        [max]="sliderOptions.ceil"
        discrete="true"
        [displayWith]="sliderOptions.translate"
        [disabled]="isLoading()"
      >
        <input
          matSliderThumb
          [(ngModel)]="confidenceLevel"
          (ngModelChange)="onConfidenceLevelChange($event)"
        />
      </mat-slider>
    </div>
  }
</div>
